export const compositeString = (parts: Array<string>, separator = '_'): string => parts.join(separator);
